import PortalVue from 'portal-vue'
import type { App } from 'vue';

export default async (app: App) => {
  app.use(PortalVue)
  return;
}
